module.exports = __webpack_public_path__ + "media/app/google-play-badge-en-7b874d0c.svg";